export const APP_INIT = 'pp/app/INIT';

export const appInit = () => ({ type: APP_INIT });
